import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addNewCourier, fetchAllCouriers, updateCourier } from '../../redux/actions/courierActions'
import { CustomDataTable, DropImageUploader } from '../../components'
import { RiEdit2Line, RiDeleteBin6Line, RiEyeLine } from 'react-icons/ri'
import { HiOutlineXCircle } from "react-icons/hi"
import { BASE_URL } from '../../constant'
import Modal from 'react-modal'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'

const Couriers = () => {
    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.admin);
    const { couriers, loader, errors } = useSelector((state) => state.couriers);

    const [modalIsOpen, setIsOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editCourierId, setEditCourierId] = useState(null);

    useEffect(() => {
        if (token) {
          dispatch(fetchAllCouriers({ token }));
        }
    }, [dispatch, token]);

    const handleView = (id) => console.log("View Customer:", id);
    const handleDelete = (id) => console.log("Delete Customer:", id);
    
    const columns = [
        {
          name: "Name",
          selector: (row) => (
            <div className=''>
                <Link to={row.website} className='d-flex fd-col grid-gap-10 fs-xs text-neutral-dark-200'>
                  <img src={ BASE_URL + row.logo } alt={row.slug} width={70} height={60} style={{ objectFit: "contain" }} />
                  {/* {row.name} */}
                </Link>
            </div>
          ),
          width: "150px",
        },
        {
          name: "Slug",
          selector: (row) => row.slug,
          width: "130px",
        },
        {
            name: "Status",
            selector: (row) => {
              if(row.is_active) {
                return <spa className="onlineBtn"><span></span>Active</spa>
              } else {
                return <spa className="codBtn"><span></span>Inactive</spa>
              }
            },
            width: "120px",
        },
        {
          name: "Consignments",
          selector: (row) => "N/A",
        },
        {
          name: "COD",
          selector: (row) => "N/A",
        },
        {
          name: "Prepaid",
          selector: (row) => "N/A",
        },
        {
          name: "Actions",
          cell: (row) => (
            <div className="actionsWrapper">
              <div onClick={() => handleView(row.id)}>
                <RiEyeLine />
              </div>
              <div onClick={() => handleEdit(row)}>
                <RiEdit2Line /> 
              </div>
              <div onClick={() => handleDelete(row.id)}>
                <RiDeleteBin6Line />
              </div>
            </div>
          ),
          ignoreRowClick: true,
          allowOverflow: true,
          button: true,
        },
    ];

    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '2rem',
          borderRadius: '16px',
          backgroundColor: '#fff',
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
          width: '90%',
          maxWidth: '500px',
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
        },
    };

    const [formData, setFormData] = useState({
        name: '',
        website: '',
        logo: null,
        is_active: true,
        old_logo: '',
    });

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked }));
        } else if (type === 'file') {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleImageUpload = (imageFile) => {
        setFormData(prev => ({ ...prev, logo: imageFile }));
    };

    const handleEdit = (courier) => {
      // alert(courier.id)
      setFormData({
        name: courier.name,
        website: courier.website,
        logo: null,
        is_active: courier.is_active,
        old_logo: courier.logo,
      });
      setEditCourierId(courier.id);
      setIsEditing(true);
      setIsOpen(true);
    };

    const handleSubmit = () => {
        const data = new FormData();
        data.append('name', formData.name); // assuming formData has name, website, etc.
        data.append('website', formData.website || '');
        data.append('is_active', formData.is_active ? 1 : 0); // or whatever boolean you use
        data.append('old_logo', formData.old_logo || '');
      
        if (formData.logo) {
          data.append(`logo_${editCourierId}`, formData.logo); // ✅ append the actual File object
        }
        
        if (isEditing) {
          dispatch(updateCourier({ token, data, id: editCourierId }))
            .unwrap()
            .then(() => {
              toast.success('Updated successfully!');
              dispatch(fetchAllCouriers({ token }));
              setIsOpen(false);
              setIsEditing(false);
              setEditCourierId(null);
            })
            .catch((err) => {
              console.error('Error:', err);
              toast.error('Failed to update courier');
            });
        } else {
          dispatch(addNewCourier({ token, data }))
            .unwrap()
            .then(() => {
              toast.success('Added successfully!');
              dispatch(fetchAllCouriers({ token }));
              setIsOpen(false);
            })
            .catch((err) => {
              console.error('Error:', err);
              toast.error('Failed to add courier');
            });
        }
    };
      
    const onAddNew = () => {
      setFormData({
        name: '',
        website: '',
        logo: null,
        is_active: true,
        old_logo: '',
      });
      setIsEditing(false);
      setEditCourierId(null);
      setIsOpen(true);
    }
    
    return (
        <>
        <div>
          {loader && <p>Loading...</p>}
          {errors && <p style={{ color: "red" }}>Error: {errors}</p>}
          {!loader && !errors && (
            <div className="ContainerBox">
              <CustomDataTable 
                columns={columns} 
                data={couriers} title="All Couriers" 
                right={(
                    <div className='divBtn' onClick={() => onAddNew()}>+ Add new</div>
                )} 
              />
            </div>
          )}
        </div>

        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => {
              setIsOpen(false);
              setIsEditing(false);
              setEditCourierId(null);
            }}
            contentLabel="Example Modal"
            style={customStyles}
        >
            <div className='formModal_container'>
                <div className='formModal_heading_wrapper'>
                    <span className='title'>{isEditing ? 'Edit Courier' : 'Add New Courier'}</span>
                    <HiOutlineXCircle 
                      className='close' 
                      onClick={() => {
                        setIsOpen(false);
                        setIsEditing(false);
                        setEditCourierId(null);
                      }} 
                    />
                </div>

                <div className='formModal_content_wrapper'>
                    <div className='formGroup'>
                    <label className='formGroup_label'>Courier name <span>*</span></label>
                    <input
                        type="text"
                        name="name"
                        className='formGroup_input'
                        placeholder='Eg. DTDC'
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                    </div>

                    <div className='formGroup'>
                    <label className='formGroup_label'>Website <small>(Optional)</small></label>
                    <input
                        type="text"
                        name="website"
                        className='formGroup_input'
                        placeholder='Eg. www.dtdc.com'
                        value={formData.website}
                        onChange={handleChange}
                    />
                    </div>

                    <div className='formGroup'>
                        <label className='formGroup_label'>Logo <small>(Optional)</small></label>
                        <DropImageUploader 
                          name="logo" 
                          onUpload={(file) => setFormData((prev) => ({ ...prev, logo: file }))}
                          preview={formData.logo ? URL.createObjectURL(formData.logo) : BASE_URL + formData.old_logo} 
                        />
                    </div>

                    <div className='formGroup'>
                    <div className='SwitchContainer'>
                        <label>Status:</label>
                        <label className='CustomSwitchLabel'>
                        <input
                            type='checkbox'
                            name='is_active'
                            className='CustomSwitchInput'
                            checked={formData.is_active}
                            onChange={handleChange}
                        />
                        <span className='CustomSwitchSlider'></span>
                        </label>
                    </div>
                    </div>

                </div>
                <div
                    className='divBtn'
                    style={{ width: 'fit-content', marginTop: 20, marginLeft: 'auto' }}
                    onClick={handleSubmit}
                >
                  {isEditing ? 'Update Courier' : '+ Save & Add Another'}
                </div>
            </div>
        </Modal>
        </>
    );
}

export default Couriers